import React from "react";

import clsx from "clsx";

import { IconPerson } from "@busbud/horizon";

import { FooterLink } from "../../footer-link";

interface Props {
  link?: string;
  label: string;
  onClick?: () => void;
  hideIcon?: boolean;
  className?: string;
}

export const AccountItemLayout: React.FC<Props> = ({
  link,
  hideIcon,
  className,
  ...other
}) => {
  return (
    <FooterLink
      iconStart={
        !hideIcon ? (
          <IconPerson
            size="md"
            variant="default"
            className="mr-050 text-icon-color-primary"
          />
        ) : undefined
      }
      className={clsx(
        "no-underline",
        {
          ["-mb-050 -ml-050 -mt-050 mr-0 flex items-center whitespace-nowrap p-0"]:
            !hideIcon
        },
        className
      )}
      // @ts-expect-error
      link={link}
      {...other}
    />
  );
};
